module.exports = __webpack_public_path__ + "static/media/direccion3.2e8b6e97.png";